import React from "react";
import { SwipeableDrawer, Box, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Field from "../Field/Fi";
import Button from "../Button/Button";
function BottomOfferModal({ open, toggleDrawer }) {
  return (
    <SwipeableDrawer
      anchor="bottom"
      open={open}
      onClose={() => toggleDrawer(false)}
      ModalProps={{
        keepMounted: true,
      }}
      PaperProps={{
        sx: {
          boxShadow:
            "0px -8px 10px rgba(0, 0, 0, 0.14), 0px -3px 14px rgba(0, 0, 0, 0.12), 0px -5px 5px rgba(0, 0, 0, 0.2)",
          borderRadius: "16px 16px 0px 0px",
        },
      }}
    >
      <CloseIcon
        onClick={() => toggleDrawer(false)}
        sx={{
          width: "16px",
          height: "16px",
          marginLeft: "16px",
          marginTop: "24px",
          "&:hover": {
            cursor: "pointer",
          },
        }}
      />
      <Box
        sx={{
          padding: "24px 16px",
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            fontSize: "14px",
            lineHeight: "20px",
            fontWeight: "600",
            marginBottom: "4px",
          }}
        >
          Price offered by seller
        </Typography>
        <Typography
          variant="h3"
          sx={{ fontSize: "22px", lineHeight: "26px", fontWeight: "600" }}
        >
          USD 800,000
        </Typography>
        <Typography
          variant="caption"
          sx={{
            fontSize: "12px",
            lineHeight: "16px",
            fontWeight: "400",
            color: "#616161",
          }}
        >
          Excluding taxes, shipping and other logistics.
        </Typography>
        <Box sx={{ marginTop: "24px" }}>
          <Typography
            variant="caption"
            sx={{
              fontSize: "12px",
              lineHeight: "16px",
              fontWeight: "400",
              color: "#616161",
            }}
          >
            Please submit your offer in{" "}
            <span style={{ fontWeight: "700", color: "#1f1f1f" }}>USD</span>
          </Typography>
          <Field
            label=""
            value="800,000"
            size="small"
            height="46px"
            inputStyle={{
              background: "#fff",
              fontSize: "16px",
              lineHeight: "24px",
              fontWeight: "600",
            }}
            sx={{ marginBottom: "24px", width: "100%" }}
          />
          <Button
            bgColor="#F9D548"
            hoverBg="#F3C04F"
            txColor="text.primary"
            typoSize="16px"
            typoVariant="subtitle1"
            fontWeight="600"
            sx={{ width: "100%", lineHeight: "24px", height: "48px" }}
          >
            Make an offer
          </Button>
        </Box>
      </Box>
    </SwipeableDrawer>
  );
}

export default BottomOfferModal;
